module.exports = __webpack_public_path__ + "static/media/search.d97f4249.svg";